import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=46367806&scoped=true&"
import script from "./PopupLayout.vue?vue&type=script&lang=js&"
export * from "./PopupLayout.vue?vue&type=script&lang=js&"
import style0 from "./PopupLayout.vue?vue&type=style&index=0&id=46367806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46367806",
  null
  
)

export default component.exports